import { combineReducers } from "redux";

import { RESPONSE_LOGOUT } from "../actions/authActions";

import appStateReducer from "./appStateReducer";
import authReducer from "./authReducer";
import signInReducer from "./signInReducer";
import filterCarsReducer from "./filterCarsReducer";
import carsReducer from "./carsReducer";

import mainMapReducer from "./mainMapReducer";

import carShortInfoReducer from "./carShortInfoReducer";
import carsTypesReducer from "./carsTypesReducer";
import carsBrandsReducer from "./carsBrandsReducer";
import carsGroupsReducer from "./carsGroupsReducer";
import choosedCarReducer from "./choosedCarReducer";
import modalReducer from "./modalReducer";
import itemsIntellegenceReducer from "./itemsIntellegenceReducer";
import setCarBookmarkReducer from "./setCarBookmarkReducer";
import deleteCarBookmarkReducer from "./deleteCarBookmarkReducer";
import carMapStateReducer from "./carMapStateReducer";
import sensorsReducer from "./sensorsReducer";
import timerangeIntelligenceReducer from "./timerangeIntelligenceReducer";
import intelligenceTimeRangePlayerReducer from "./intelligenceTimeRangePlayerReducer";
import dashboardsReducer from "./dashboardsReducer";
import dashboardsCodesReducer from "./dashboardsCodesReducer";
import reportsListReducer from "./reportsListReducer";

import selectedCarsReducer from "./selectedCarsReducer";
import reportTimeReducer from "./reportTimeReducer";

import reportReducer from "./reportReducer";
import reportGetStateReducer from "./reportGetStateReducer";
import reportsHistoryReducer from "./reportsHistoryReducer";

import savedReportsReducer from "./savedReportsReducer";
import saveReportReducer from "./saveReportReducer";
import deleteReportReducer from "./deleteReportReducer";
import filterSavedReportsReducer from "./filterSavedReportsReducer";

import intelligenceDateControlsReducer from "./intelligenceDateControlsReducer";
import positionsReducer from "./positionsReducer";
import timeRangeIntelligenceTypeReducer from "./timeRangeIntelligenceTypeReducer";
import messagesReducer from "./messagesReducer";
import mapPositionsReducer from "./mapPositionsReducer";
import mapOrigenalPositionsReducer from "./mapOrigenalPositionsReducer";
import chartSensorsReducer from "./chartSensorsReducer";
import mapParkingsReducer from "./mapParkingsReducer";

import selectedReportsReducer from "./selectedReportsReducer";
import reportCarReducer from "./reportCarReducer";
import reportDateControlsReducer from "./reportDateControlsReducer";
import reportDataReducer from "./reportDataReducer";
import reportFieldsReducer from "./reportFieldsReducer";
import unitReportReducer from "./unitReportReducer";
import saveUnitReportReducer from "./saveUnitReportReducer";
import reportFormatsReducer from "./reportFormatsReducer";
import downloadReportsReducer from "./downloadReportsReducer";
import downloadUnitReportReducer from "./downloadUnitReportReducer";
import downloadSavedReportReducer from "./downloadSavedReportReducer";
import mapMapBaseLayerControlReducer from "./mapMapBaseLayerControlReducer";
import mapFuelingsReducer from "./mapFuelingsReducer";
import mapDrainsReducer from "./mapDrainsReducer";
import geozonesReducer from "./geozonesReducer";
import companiesReducer from "./companiesReducer";
import serviceHistoryReducer from "./serviceHistoryReducer";
import changeUnitReducer from "./changeUnitReduser";
import devicesReducer from "./devicesReducer";
import listSensorsReducer from "./listSensorsReducer";
import currentDeviceReducer from "./currentDeviceReducer";
import usersReducer from "./usersReduser";
import rolesReducer from "./rolesReduser";
import registrationReducer from "./registrationReduser";
import restoreReducer from "./restoreReduser";
import permissionsReducer from "./permissionsReducer";
import ownersipAreasReducer from "./pwnershipAreasReducer";
import intelligenceControlReducer from "./intelligenceControlReducer";
import analiseSignalsReducer from "./analiseSignalsReducer";
import companyGroupsReducer from "./companyGroupsReducer";
import dataAnalyseTimeRangeReducer from "./dataAnalyseTimeRangeReducer";
import dataAnalyseReducer from "./dataAnalyseReducer";
import routesReducer from "./routeReducer";
import routeControlPointReducer from "./routeControlPointReducer";
import controlPointsReducer from "./controlPointsReducer";
import createControlPointReducer from "./createControlPointReducer";
import signalRReducer from "./signalRReducer";
import popupNotificationsReducer from "./popupNotificationsReducer";
import reprocessUnitsReducer from "./reprocessUnitsReducer";
import customReportReducer from "./customReportReducer";
import winterReducer from "./winterReducer";
import winterMaintenceReducer from "./winterMaintenceReducer";
import winterMaintenceTimeRangeReducer from "./winterMaintenceTimeRangeReducer";
import notificationsReducer from "./notificationsReducer";
import logisticControlPointsReducer from "./logisticControlPointsReducer";
import geocoderReducer from "./geocoderReducer";
import logosticFilterReduser from "./logosticFilterReduser";
import logisticGroupsReducer from "./logisticGroupsReducer";
import logisticRoutesReducer from "./logisticRoutesReducer";
import downloadFilesReducer from "./downloadFilesReducer";
import logisticTripsReducer from "./logisticTripsReducer";
import logisticTripRoutesReducer from "./logisticTripRoutesReducer";
import logisticTripControlPointsReducer from "./logisticTripControlPointsReducer";
import logisticReportsReducer from "./logisticReportsReducer";
import logisticMonitoringTaskTripsReducer from "./logisticMonitoringTaskTripsReducer";
import exceptionsReducer from "./exceptionsReducer";
import mapGpsJammingsReducer from "./mapGpsJammingsReducer";
import videoToolsReducer from "./videoToolsReducer";
import integrationsReducer from "./integrationsReducer";
import videoDevicesReducer from "./videoDevicesReducer";
import retranslationsReducer from "./retranslationsReducer";
import driversReducer from "./driversReducer";
import routeSpeedColorReducer from "./routeSpeedColorReducer";
import mapSpeedingPointsReducer from "./mapSpeedingPointsReducer";
import jobRequestsReducer from "./jobRequestsReducer";

const appReducers = combineReducers({
  appState: appStateReducer,
  auth: authReducer,
  signInForm: signInReducer,
  filterCars: filterCarsReducer,
  units: carsReducer,
  unitShortInfo: carShortInfoReducer,

  mainMap: mainMapReducer,
  carsTypes: carsTypesReducer,
  carsBrands: carsBrandsReducer,
  carsGroups: carsGroupsReducer,
  choosedCar: choosedCarReducer,
  modal: modalReducer,
  itemsIntellegence: itemsIntellegenceReducer,
  setCarBookmark: setCarBookmarkReducer,
  deleteCarBookmark: deleteCarBookmarkReducer,
  carMapState: carMapStateReducer,
  sensors: sensorsReducer,
  timerangeIntelligence: timerangeIntelligenceReducer,
  intelligenceTimeRangePlayer: intelligenceTimeRangePlayerReducer,
  dashboards: dashboardsReducer,
  dashboardsCodes: dashboardsCodesReducer,
  reportsList: reportsListReducer,
  selectedCars: selectedCarsReducer,
  reportRangeTime: reportTimeReducer,
  report: reportReducer,
  reportGetState: reportGetStateReducer,
  savedReports: savedReportsReducer,
  saveReport: saveReportReducer,
  deleteReport: deleteReportReducer,
  reportsHistory: reportsHistoryReducer,
  filterSavedReports: filterSavedReportsReducer,
  intelligenceDateControls: intelligenceDateControlsReducer,
  positions: positionsReducer,
  parkings: mapParkingsReducer,
  origenalPositions: mapOrigenalPositionsReducer,
  timeRangeIntelligenceType: timeRangeIntelligenceTypeReducer,
  messages: messagesReducer,
  mapPositions: mapPositionsReducer,
  chartSensors: chartSensorsReducer,
  selectedReports: selectedReportsReducer,
  reportCar: reportCarReducer,
  reportDateControls: reportDateControlsReducer,
  reportData: reportDataReducer,
  reportFields: reportFieldsReducer,
  unitReport: unitReportReducer,
  saveUnitReport: saveUnitReportReducer,
  reportFormats: reportFormatsReducer,
  downloadReports: downloadReportsReducer,
  downloadUnitReport: downloadUnitReportReducer,
  downloadSavedReport: downloadSavedReportReducer,
  mapBaseLayer: mapMapBaseLayerControlReducer,
  fuelings: mapFuelingsReducer,
  drains: mapDrainsReducer,
  geozones: geozonesReducer,
  ownershipAreas: companiesReducer,
  serviceHistory: serviceHistoryReducer,
  currentUnit: changeUnitReducer,
  devices: devicesReducer,
  listSensors: listSensorsReducer,
  currentDevice: currentDeviceReducer,
  users: usersReducer,
  roles: rolesReducer,
  registration: registrationReducer,
  restore: restoreReducer,
  permissions: permissionsReducer,
  userOwnershipAreas: ownersipAreasReducer,
  intelligenceControl: intelligenceControlReducer,
  analiseSignals: analiseSignalsReducer,
  companyGroups: companyGroupsReducer,
  dataAnalyseTimeRange: dataAnalyseTimeRangeReducer,
  dataAnalyse: dataAnalyseReducer,
  routes: routesReducer,
  routeControlPoint: routeControlPointReducer,
  controlPoints: controlPointsReducer,
  createControlPoint: createControlPointReducer,
  signalR: signalRReducer,
  popupNotifications: popupNotificationsReducer,
  reprocessUnits: reprocessUnitsReducer,
  customReport: customReportReducer,
  winter: winterReducer,
  winterMaintence: winterMaintenceReducer,
  winterMaintenceTimeRange: winterMaintenceTimeRangeReducer,
  notifications: notificationsReducer,
  logisticControlPoints: logisticControlPointsReducer,
  geocoder: geocoderReducer,
  logosticFilter: logosticFilterReduser,
  logisticGroups: logisticGroupsReducer,
  logisticRoutes: logisticRoutesReducer,
  downloadFiles: downloadFilesReducer,
  logisticTrips: logisticTripsReducer,
  logisticTripRoutes: logisticTripRoutesReducer,
  logisticTripControlPoints: logisticTripControlPointsReducer,
  logisticReports: logisticReportsReducer,
  monitoringTaskTrips: logisticMonitoringTaskTripsReducer,
  exceptions: exceptionsReducer,
  gpsJammings: mapGpsJammingsReducer,
  videoTools: videoToolsReducer,
  integrations: integrationsReducer,
  videoDevices: videoDevicesReducer,
  retranslations: retranslationsReducer,
  drivers: driversReducer,
  routeSpeedColor: routeSpeedColorReducer,
  speedingPoints: mapSpeedingPointsReducer,
  jobRequests: jobRequestsReducer,
});

const reducers = (state, action) => {
  if (action.type === RESPONSE_LOGOUT) {
    state = undefined;
  }

  return appReducers(state, action);
};

export default reducers;
